import { ChangeEvent, FC, useState } from "react";
import { useDispatch } from "react-redux";

import { IFormSettings } from "./../../../../services/forms";
import { IEmailEditorData } from "../../../../store/settings/types";
import { changeNotificationSettings } from "./../../../../store/settings/actionCreators";

import RespondtSelect from "./../../General/GeneralSelect";
import { IconTypes } from "./../../../../libs/Icon";
import Button from "./../../../../libs/Button";
import Switch from "./../../../../libs/Switch";
import NotificationTextEditor from "./NotificationTextEditor";

import styles from "./styles.module.scss";

interface IProps {
    notificationSettings: IFormSettings["notification"];
}

const RespondentNotification: FC<IProps> = ({ notificationSettings }) => {
    const dispatch = useDispatch();

    const [emailToRespondentSubject, setEmailToRespondentSubject] = useState<string>(
        notificationSettings.emailToRespondent.subject,
    );
    const [emailToRespondentSenderName, setEmailToRespondentSenderName] = useState<string>(
        notificationSettings.emailToRespondent.senderName,
    );
    const [emailToRespondentReplyToEmail, setEmailToRespondentReplyToEmail] = useState<string>(
        notificationSettings.emailToRespondent.replyToEmail,
    );
    const [emailRespondentMassage, setEmailRespondentMassage] = useState<IEmailEditorData>({
        html: notificationSettings.emailToRespondent.message,
        json: notificationSettings.emailToRespondent.json,
    });
    const [, setEmailRespondentIsActive] = useState<boolean>(notificationSettings.emailToRespondent.isActive);

    const [emailRespondentTo, setEmailRespondentTo] = useState<string>(notificationSettings.emailToRespondent.to);

    const handleEmeilRespondentSubject = (e: ChangeEvent<HTMLInputElement>) =>
        setEmailToRespondentSubject(e.target.value);

    const handleEmeilRespondentSenderName = (e: ChangeEvent<HTMLInputElement>) =>
        setEmailToRespondentSenderName(e.target.value);

    const handleEmeilRespondentReplyToEmail = (e: ChangeEvent<HTMLInputElement>) =>
        setEmailToRespondentReplyToEmail(e.target.value);

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeNotificationSettings({
                prevState: notificationSettings,
                currentState: element.notification,
            }),
        );
    };

    return (
        <div className={styles.section}>
            <label className={styles.switchContainer}>
                <Switch
                    checked={notificationSettings.emailToRespondent.isActive}
                    onChange={() => {
                        setEmailRespondentIsActive(state => !state);
                        handleStateUpdate({
                            notification: {
                                ...notificationSettings,
                                emailToRespondent: {
                                    ...notificationSettings.emailToRespondent,
                                    isActive: !notificationSettings.emailToRespondent.isActive,
                                },
                            },
                        });
                    }}
                />

                <p className={styles.subTitle}>Email to Respondent</p>
            </label>

            {notificationSettings.emailToRespondent.isActive && (
                <>
                    <span className={styles.label}>Send confirmation Email to users.</span>

                    <span className={styles.subTitle}>
                        Subject
                        <Button icon={IconTypes.SINGLE_LINE} iconSize={18} />
                    </span>

                    <input
                        type="text"
                        value={emailToRespondentSubject}
                        onChange={e => handleEmeilRespondentSubject(e)}
                        className={styles.customInput}
                        onBlur={() =>
                            handleStateUpdate({
                                notification: {
                                    ...notificationSettings,
                                    emailToRespondent: {
                                        ...notificationSettings.emailToRespondent,
                                        subject: emailToRespondentSubject,
                                    },
                                },
                            })
                        }
                    />

                    <div className={styles.rowContainer}>
                        <div className={styles.senderDiv}>
                            <span className={styles.subTitle}>Sender Name</span>

                            <input
                                type="text"
                                value={emailToRespondentSenderName}
                                onChange={e => handleEmeilRespondentSenderName(e)}
                                className={styles.customInput}
                                onBlur={() =>
                                    handleStateUpdate({
                                        notification: {
                                            ...notificationSettings,
                                            emailToRespondent: {
                                                ...notificationSettings.emailToRespondent,
                                                senderName: emailToRespondentSenderName,
                                            },
                                        },
                                    })
                                }
                            />
                        </div>

                        <div className={styles.mailDiv}>
                            <div className={styles.label}>To</div>
                            <RespondtSelect
                                isLimit
                                selectedItem={emailRespondentTo}
                                options={{ Email: "Email", Email2: "Email2" }}
                                setState={(newKey: string) => {
                                    setEmailRespondentTo(newKey);

                                    handleStateUpdate({
                                        notification: {
                                            ...notificationSettings,
                                            emailToRespondent: {
                                                ...notificationSettings.emailToRespondent,
                                                to: newKey,
                                            },
                                        },
                                    });
                                }}
                            />
                        </div>

                        <div className={styles.replyDiv}>
                            <span className={styles.subTitle}>Reply - To Email</span>

                            <input
                                type="text"
                                value={emailToRespondentReplyToEmail}
                                onChange={e => handleEmeilRespondentReplyToEmail(e)}
                                className={styles.customInput}
                                onBlur={() =>
                                    handleStateUpdate({
                                        notification: {
                                            ...notificationSettings,
                                            emailToRespondent: {
                                                ...notificationSettings.emailToRespondent,
                                                replyToEmail: emailToRespondentReplyToEmail,
                                            },
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>

                    <span className={styles.subTitle}>Message</span>

                    <NotificationTextEditor
                        handleChange={e => {
                            setEmailRespondentMassage(e);
                            handleStateUpdate({
                                notification: {
                                    ...notificationSettings,
                                    emailToRespondent: {
                                        ...notificationSettings.emailToRespondent,
                                        message: e.html,
                                        json: e.json,
                                    },
                                },
                            });
                        }}
                        invoiceInitial={emailRespondentMassage}
                    />
                </>
            )}
        </div>
    );
};

export default RespondentNotification;
